config.$inject = [
    '$httpProvider',
    '$interpolateProvider',
];

export default function config(
    $httpProvider,
    $interpolateProvider,
) {
    $interpolateProvider.startSymbol('{[{').endSymbol('}]}');

    $httpProvider.useApplyAsync(true);
    // TODO: $httpProvider.interceptors.push('errorInterceptor');
    $httpProvider.interceptors.push('basicAuthInterceptor');
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
}
